// extracted by mini-css-extract-plugin
export default {"offerCard":"OfferCard_offerCard__6NzC5"};